// Vendors
import { apiUtils } from '@openbank/cf-ui-architecture-core';
// Constants
import { LOG_SERVICE_CONFIGURATION } from './constants/log.service.constants';

const logCustomActionService = async (description: string): Promise<[null, Response]> =>
  apiUtils.post({ ...LOG_SERVICE_CONFIGURATION, params: { description } });

export { logCustomActionService };
